class BtCompareUtil
{
  static init() {
    BtCompareUtil.key = 'compare';
    BtCompareUtil.activeCategoryKey = 'compare-active-category';
    BtCompareUtil.defaultCategory = 'Other';

    // Set max items to 4 (per category)
    BtCompareUtil.maxItems = 4;

    BtCompareUtil.bubbleHtmlClass = '.compare-count-bubble';
    BtCompareUtil.updateCompareBubble(true);
    BtCompareUtil.loadedContent = false;
  }

  static getCompareData() {
    const data = BtStorageUtil.get(BtCompareUtil.key, true);
    // Guard against the old flat-array shape from before categories existed
    if (!data || typeof data !== 'object' || Array.isArray(data)) return {};
    return data;
  }

  static setCompareData(data) {
    BtStorageUtil.set(BtCompareUtil.key, data);
  }

  static getCompareArray(category) {
    const data = BtCompareUtil.getCompareData();
    return (data[category] || []).slice(0, BtCompareUtil.maxItems);
  }

  static getAllCategories() {
    const data = BtCompareUtil.getCompareData();
    return Object.keys(data).filter((category) => data[category] && data[category].length > 0);
  }

  static getAllIds() {
    const data = BtCompareUtil.getCompareData();
    return Object.values(data).flat();
  }

  static getActiveCategory() {
    return BtStorageUtil.get(BtCompareUtil.activeCategoryKey, false) || null;
  }

  static setActiveCategory(category) {
    if (category === BtCompareUtil.getActiveCategory()) return;
    BtStorageUtil.set(BtCompareUtil.activeCategoryKey, category);
    // Whatever's cached for the modal belongs to the previously active category now
    BtCompareUtil.loadedContent = false;
    document.dispatchEvent(new CustomEvent('compareActiveCategoryChanged', { detail: { category } }));
  }

  static toggleProductToCompare(productId, category) {
    category = category || BtCompareUtil.defaultCategory;
    const data = BtCompareUtil.getCompareData();
    const currentProducts = data[category] || [];
    let isAdding = false;

    if (!currentProducts.includes(productId)) {
      if (currentProducts.length >= BtCompareUtil.maxItems) {
        // show a message instead of silently failing
        pushErrorMessage(`You can only compare up to ${BtCompareUtil.maxItems} products of one type.`);
        return;
      }
      currentProducts.push(productId);
      isAdding = true;
    } else {
      const index = currentProducts.indexOf(productId);
      currentProducts.splice(index, 1);
    }

    data[category] = currentProducts;
    BtCompareUtil.setCompareData(data);
    if (isAdding) BtCompareUtil.setActiveCategory(category);
    BtCompareUtil.updateCompareBubble();
    BtCompareUtil.loadedContent = false;
    BtCompareUtil.toogleEmptyWarningClass(document.querySelector('compare-popup'));
    BtCompareUtil.notify();
  }

  static removeCompareProduct(productId) {
    const data = BtCompareUtil.getCompareData();
    let changed = false;

    Object.keys(data).forEach((category) => {
      const index = (data[category] || []).indexOf(productId);
      if (index !== -1) {
        data[category].splice(index, 1);
        changed = true;
      }
    });

    if (!changed) return;

    BtCompareUtil.setCompareData(data);
    BtCompareUtil.updateCompareBubble();
    BtCompareUtil.loadedContent = false;
    BtCompareUtil.notify();
  }

  static clearAll() {
    BtCompareUtil.setCompareData({});
    BtCompareUtil.updateCompareBubble();
    BtCompareUtil.loadedContent = false;
    BtCompareUtil.notify();
  }

  static notify() {
    document.dispatchEvent(new CustomEvent('compareUpdated', { detail: { ids: BtCompareUtil.getAllIds() } }));
  }

  static updateCompareBubble(ignoreZero = false) {
    const total = BtCompareUtil.getAllIds().length;
    if(total > 0 || !ignoreZero) {
      document.querySelectorAll(BtCompareUtil.bubbleHtmlClass).forEach(bubble => {
        bubble.textContent = total;
      });
      BtCompareUtil.updateAddedStyle(BtCompareUtil.getAllIds());
    }
  }

  static updateAddedStyle(currentProducts = []) {
    let styleTag = document.getElementById('bt-compare-style');
    if(styleTag == undefined) {
      styleTag = document.createElement('style');
      styleTag.setAttribute('id', 'bt-compare-style');
      styleTag.textContent = BtCompareUtil.generateAddedCss(currentProducts);
      document.head.appendChild(styleTag);
    } else {
      styleTag.textContent = BtCompareUtil.generateAddedCss(currentProducts);
    }
    BtCompareUtil.updateAddedState(currentProducts);
  }

  // Keeps a single button's a11y/label state (aria-pressed, aria-label, visible text) in sync with isAdded
  static applyAddedState(button, isAdded) {
    button.setAttribute('aria-pressed', String(isAdded));

    const textEl = button.querySelector('.compare-text');
    if (textEl) {
      const text = isAdded ? textEl.dataset.addedText : textEl.dataset.addText;
      if (text) textEl.textContent = text;
    }

    if (button.dataset.addLabel || button.dataset.addedLabel) {
      const label = isAdded ? button.dataset.addedLabel : button.dataset.addLabel;
      if (label) button.setAttribute('aria-label', label);
    }
  }

  static updateAddedState(currentProducts = []) {
    const addedSet = new Set(currentProducts.map(String));
    document.querySelectorAll('.compare-add-button').forEach((button) => {
      BtCompareUtil.applyAddedState(button, addedSet.has(String(button.dataset.productId)));
    });
  }

  static generateAddedCss(currentProducts = []) {
    let cssContent = '';
    if(currentProducts.length > 0) {
      currentProducts.forEach(productId => {
        if(cssContent != '') {
          cssContent += ',';
        }
        cssContent += `.compare-add-button[data-product-id="${productId}"] .compare-added-check`;
      });
      cssContent += '{opacity:1;}'
    }
    return cssContent;
  }

  static toogleEmptyWarningClass(popup) {
    const size = BtCompareUtil.getCompareArray(BtCompareUtil.getActiveCategory()).length;

    popup.classList.remove('empty', 'warning', 'empty-ui');

    if (size > 1) return;

    // if (size === 1) {
    //   popup.classList.add('warning');
    //   return;
    // }

    // size === 0: show your custom empty UI, not the banner
    popup.classList.add('empty-ui');
  }
}

BtCompareUtil.init();

class ComparePopup extends HTMLElement
{
  constructor() {
    super();
    this.assets = document.getElementById('compare-modal-assets');
    this.results = this.querySelector('.compare-modal__results');
    this.tabs = document.getElementById('CompareModalTabs');
    this.header = this.tabs ? this.tabs.closest('.compare-modal__header') : null;
    this.hasAssets = false;
    this.loadToken = 0;
  }

  connectedCallback() {
    this.onSwapProductOutsideNodeHandler = this.onSwapProductOutsideNode.bind(this);
    document.addEventListener('swapProductOutsideNode', this.onSwapProductOutsideNodeHandler);

    this.onResizeHandler = () => this.updateStickyRows();
    window.addEventListener('resize', this.onResizeHandler);

    // Re-measures sticky-row offsets if row 1's image loads late and grows it
    this.stickyRowObserver = new ResizeObserver(() => this.updateStickyRows());

    // Stops Escape from also closing the whole modal while the mobile add-product drawer is open
    this.onKeyupHandler = (e) => {
      if (e.key !== 'Escape') return;
      if (e.target.closest('.compare-mobile-add__drawer')) e.stopPropagation();
    };
    this.addEventListener('keyup', this.onKeyupHandler);

    // Collapses the sticky product-card rows to a compact bar once the table's been scrolled,
    // so the comparison rows below aren't fighting the full-height card for viewport space
    this.scrollParent = this.closest('.popup-modal__content');
    this.onScrollHandler = () => this.updateCompactState();
    if (this.scrollParent) this.scrollParent.addEventListener('scroll', this.onScrollHandler, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('swapProductOutsideNode', this.onSwapProductOutsideNodeHandler);
    window.removeEventListener('resize', this.onResizeHandler);
    this.removeEventListener('keyup', this.onKeyupHandler);
    this.stickyRowObserver.disconnect();
    if (this.scrollParent) this.scrollParent.removeEventListener('scroll', this.onScrollHandler);
  }

  updateCompactState() {
    if (!this.scrollParent) return;
    this.classList.toggle('is-compact', this.scrollParent.scrollTop > 16);
  }

  updateStickyRows() {
    const rows = Array.from(this.querySelectorAll('.compare-popup__row')).slice(0, ComparePopup.stickyRowCount);
    // lives next to the header now, outside this element's own subtree
    const mobileAdd = this.header ? this.header.parentElement.querySelector('.compare-mobile-add') : this.querySelector('.compare-mobile-add');
    this.stickyRowObserver.disconnect();

    const headerHeight = this.header ? this.header.getBoundingClientRect().height : 0;
    if (this.header) this.stickyRowObserver.observe(this.header);

    if (!window.matchMedia('(min-width: 750px)').matches) {
      // rows aren't sticky on mobile, but the add-product trigger stays pinned below the header
      rows.forEach((row) => {
        row.querySelectorAll('th, td').forEach((cell) => {
          cell.style.top = '';
        });
      });
      if (mobileAdd) mobileAdd.style.top = `${headerHeight}px`;
      return;
    }

    if (mobileAdd) mobileAdd.style.top = '';
    if (!rows.length) return;

    let offset = headerHeight;

    rows.forEach((row) => {
      this.stickyRowObserver.observe(row);
      const height = row.getBoundingClientRect().height;
      row.querySelectorAll('th, td').forEach((cell) => {
        cell.style.top = `${offset}px`;
      });
      offset += height;
    });
  }

  renderTabs(categories) {
    const activeCategory = BtCompareUtil.getActiveCategory();
    this.tabs.innerHTML = '';

    if (categories.length < 2) return;

    categories.forEach((category) => {
      const count = BtCompareUtil.getCompareArray(category).length;
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'compare-drawer__tab';
      tab.setAttribute('aria-selected', String(category === activeCategory));
      if (category === activeCategory) tab.classList.add('compare-drawer__tab--active');
      tab.innerHTML = `<span>${category}</span><span class="compare-drawer__tab-count">${count}</span>`;
      tab.addEventListener('click', () => this.switchTab(category));
      this.tabs.appendChild(tab);
    });
  }

  switchTab(category) {
    if (category === BtCompareUtil.getActiveCategory()) return;
    BtCompareUtil.setActiveCategory(category);
    this.loadContent();
  }

  reorderColumns(orderedIds) {
    this.results.querySelectorAll('tr.compare-popup__row').forEach((row) => {
      const productCells = new Map();
      const otherCells = [];

      Array.from(row.querySelectorAll('td')).forEach((td) => {
        const match = Array.from(td.classList).find((c) => c.startsWith('product-compare-'));
        if (match) {
          productCells.set(match.slice('product-compare-'.length), td);
        } else {
          otherCells.push(td);
        }
      });

      orderedIds.forEach((id) => {
        const td = productCells.get(String(id));
        if (td) row.appendChild(td);
      });
      otherCells.forEach((td) => row.appendChild(td));
    });
  }

  loadContent() {
    if(BtCompareUtil.loadedContent) return;
    this.classList.add('loading');
    const activeCategory = BtCompareUtil.getActiveCategory();
    const currentProducts = BtCompareUtil.getCompareArray(activeCategory);
    const newIds = [];
    currentProducts.forEach(productId => {
      newIds.push(`id:${productId}`);
    });
    const idsQuery =  newIds.join(' OR ');
    // Toggling a product mid-flight starts a second, overlapping fetch — without this token,
    // whichever response lands last would win even if it's the stale one, overwriting the
    // modal with an outdated product list
    const requestToken = ++this.loadToken;
    return fetch(`${window.routes.search_url}?section_id=product-compare&q=${idsQuery}&type="product"`)
    .then((response) => response.text())
    .then(response => {
      if (requestToken !== this.loadToken) return;

      const html = new DOMParser().parseFromString(response, 'text/html');
      const updatedResults = html.querySelector('.results');
      if(!this.hasAssets) {
        this.assets.innerHTML = html.querySelector('.assets').innerHTML;
        this.hasAssets = true;
        HTMLUpdateUtility.reinjectsScripts(this.assets);
        this.blockTypes = updatedResults.dataset.blockTypes.split(',');
      }

      this.results.innerHTML = updatedResults.innerHTML;

      // moved next to the header so it's outside the horizontally-scrolling table area;
      // remove any leftover copy from a previous render before moving the fresh one in
      if (this.header && this.header.nextElementSibling && this.header.nextElementSibling.classList.contains('compare-mobile-add')) {
        this.header.nextElementSibling.remove();
      }
      const mobileAdd = this.results.querySelector('.compare-mobile-add');
      if (mobileAdd && this.header) this.header.insertAdjacentElement('afterend', mobileAdd);

      this.reorderColumns(currentProducts);
      this.renderTabs(BtCompareUtil.getAllCategories());
      BtCompareUtil.toogleEmptyWarningClass(this);
      this.updateStickyRows();
      this.updateCompactState();

      // empty state's picker is always visible, so populate it right away
      const emptyStateResults = this.results.querySelector('.compare-empty-state .compare-picker__results');
      if (emptyStateResults) showPickerRecommendations(this, emptyStateResults);
    })
    .finally(() => {
      if (requestToken !== this.loadToken) return;
      this.classList.remove('loading');
      BtCompareUtil.loadedContent = true;
    });
  }

  onSwapProductOutsideNode(event) {
    const productUrl = event.detail.productUrl;
    fetch(`${productUrl}.json`)
    .then((response) => response.json())
    .then(response => {
      const productId = response.product.id;
      const requestUrl = `${window.routes.search_url}?section_id=product-compare&q=id:${productId}&type="product"`;

      const oldSectionId = event.detail.oldSectionId;
      fetch(requestUrl)
      .then((response) => response.text()) 
      .then(response => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const newNode = html.querySelector('product-info');
        const newSectionId = newNode.dataset.section;
        const index = event.detail.index;
        this.blockTypes.forEach((blockType) => {
          this.updateSourceFromDestination(html, oldSectionId, newSectionId, index, blockType);
        });
      });
    });

    
  }

  updateSourceFromDestination(html, oldSectionId, newSectionId, index, id, shouldHide = (source) => false) {
    const source = html.getElementById(`${newSectionId}-${id}-1`);
    const destination = document.getElementById(`${oldSectionId}-${id}-${index}`);
    if (source && destination) {
      if(id == 'featured_image') {
        destination.querySelector('.compare-popup__remove-link').dataset.productId = source.querySelector('.compare-popup__remove-link').dataset.productId;
      }
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', shouldHide(source));
      destination.id = `${newSectionId}-${id}-${index}`;
      if(id == 'options') {
        HTMLUpdateUtility.reinjectsScripts(destination);
      }
      if(id == 'add_to_cart') {
        destination.querySelector('product-info').dataset.index = index;
      }
    }
  }
}

ComparePopup.stickyRowCount = 5;

customElements.define('compare-popup', ComparePopup);

class CompareAddButton extends HTMLElement
{
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.button = this.querySelector('button');
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener('click', this.onButtonClickHandler);
  }

  connectedCallback() {
    // Self-syncs on mount so buttons rendered after the initial page load (quickview,
    // infinite-scroll grids, ajax recommendations) reflect current state immediately
    this.syncPressedState();
    this.onCompareUpdatedHandler = this.syncPressedState.bind(this);
    document.addEventListener('compareUpdated', this.onCompareUpdatedHandler);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onButtonClickHandler);
    document.removeEventListener('compareUpdated', this.onCompareUpdatedHandler);
  }

  syncPressedState() {
    const isAdded = BtCompareUtil.getAllIds().map(String).includes(this.button.dataset.productId);
    BtCompareUtil.applyAddedState(this.button, isAdded);
  }

  onButtonClick() {
    BtCompareUtil.toggleProductToCompare(this.button.dataset.productId, this.button.dataset.compareCategory);
  }
}

customElements.define('compare-add-button', CompareAddButton);

class CompareRemoveButton extends HTMLElement
{
  connectedCallback() {
    this.button = this.querySelector('a');
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener('click', this.onButtonClickHandler);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onButtonClickHandler);
  }

  onButtonClick(e) {
    e.preventDefault();

    const popup = this.closest('compare-popup');

    // resets loadedContent so the fetch below actually re-runs
    BtCompareUtil.removeCompareProduct(this.button.dataset.productId);

    popup.querySelectorAll('.compare-picker-inline').forEach(p => (p.hidden = true));

    popup.loadContent();
  }

}

customElements.define('compare-remove-button', CompareRemoveButton);

class CompareVariants extends HTMLElement
{
  constructor() {
    super();
    this.loadVariantPicker();
  }

  connectedCallback() {
    
  }

  loadVariantPicker() {
    fetch(`${this.dataset.url}?section_id=product-compare-item`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const variantPicker = html.getElementById(`compare-variants-${this.dataset.section}`);
      HTMLUpdateUtility.viewTransition(this, variantPicker);
    });
  }
}

customElements.define('compare-variants', CompareVariants);

function getComparePopupFromEventTarget(target) {
  // the mobile add-product drawer lives outside <compare-popup> in the DOM
  return target.closest('compare-popup') || document.querySelector('compare-popup');
}

function getPopup(el) {
  return el.closest('compare-popup') || document.querySelector('compare-popup');
}

function closeAllInlinePickers(popup) {
  // .block pickers have no reopen button, so never hide them here
  popup.querySelectorAll('.compare-picker-inline').forEach(p => {
    if (p.classList.contains('block')) return;
    p.hidden = true;
  });
}

const PICKER_SUGGESTION_TARGET = 8;

// only scope by category if one is actually populated (getActiveCategory can be stale)
function getScopedActiveCategory() {
  return BtCompareUtil.getAllCategories().length > 0 ? BtCompareUtil.getActiveCategory() : null;
}

async function showPickerRecommendations(popup, resultsEl) {
  const activeCategory = getScopedActiveCategory();
  const currentSet = new Set(BtCompareUtil.getAllIds().map(String));
  const contextId = BtCompareUtil.getCompareArray(activeCategory)[0];

  try {
    let html = '';
    if (contextId) {
      html = await fetchCompareRecommendations(contextId);
    } else {
      // empty compare → try this visitor's recently viewed products, else curated starters
      const recentIds = getRecentlyViewedIds();
      html = recentIds.length > 0 ? await fetchCompareRecentlyViewed(recentIds) : await fetchCompareStarters();
    }

    const container = buildFilteredPickerContainer(html, currentSet, activeCategory);
    await fillWithCategoryFallback(container, activeCategory, currentSet);
    resultsEl.innerHTML = container.innerHTML.trim() || `<div class="compare-picker__empty">No results</div>`;
  } catch {
    resultsEl.innerHTML = `<div class="compare-picker__empty">No results</div>`;
  }
}

// populates the mobile drawer's picker on open; toggle doesn't bubble, so capture phase
document.addEventListener('toggle', (e) => {
  const details = e.target.closest && e.target.closest('.compare-mobile-add__drawer details');
  if (!details || !details.hasAttribute('open')) return;

  const results = details.querySelector('.compare-picker__results');
  const popup = results && getPopup(details);
  if (popup && results && !results.innerHTML.trim()) showPickerRecommendations(popup, results);
}, true);

// pads suggestions out to targetCount from the full catalog once real recommendations run short
async function fillWithCategoryFallback(container, category, excludeIds, targetCount = PICKER_SUGGESTION_TARGET) {
  const shownIds = new Set(
    Array.from(container.querySelectorAll('[data-compare-pick-id]')).map((el) => el.getAttribute('data-compare-pick-id'))
  );
  const remaining = targetCount - shownIds.size;
  if (remaining <= 0) return;

  const items = await CompareSearchIndex.get();
  const candidates = items.filter(
    (item) => (!category || item.category === category) && !excludeIds.has(String(item.id)) && !shownIds.has(String(item.id))
  );

  // shuffle so fillers aren't always the same first few catalog items
  for (let i = candidates.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
  }

  candidates.slice(0, remaining).forEach((item) => container.appendChild(buildPickerItemElement(item)));
}

function buildPickerItemElement(p) {
  const displayTitle = p.title || '';
  const model = p.model || '';
  const img = p.image
    ? `<img class="compare-picker__image" src="${p.image}" alt="${displayTitle.replace(/"/g, '&quot;')}" loading="lazy">`
    : `<div class="compare-picker__image compare-picker__image--placeholder" aria-hidden="true"></div>`;

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'compare-picker__item';
  btn.setAttribute('data-compare-pick-id', p.id);
  btn.setAttribute('data-compare-category', p.category || '');
  btn.innerHTML = `
    ${img}
    <div class="compare-picker__content">
      ${model ? `<div class="compare-picker__meta">${model}</div>` : ''}
      <div class="compare-picker__title">${displayTitle}</div>
    </div>
  `;
  return btn;
}

function getRecentlyViewedIds() {
  if (typeof BtRecentlyViewedUtil === 'undefined') return [];
  return BtRecentlyViewedUtil.getArray()
    .map((item) => item.product_id)
    .slice(0, 10);
}

async function fetchCompareRecentlyViewed(ids) {
  const idsQuery = ids.map((id) => `id:${id}`).join(' OR ');
  const res = await fetch(`${window.routes.search_url}?section_id=compare-recently-viewed&q=${idsQuery}&type="product"`, { headers: { Accept: 'text/html' } });
  if (!res.ok) return '';
  return await res.text();
}

function openInlinePicker(btn) {
  const popup = getPopup(btn);
  if (!popup) return;

  // Warm the search index in the background so it's ready before the user finishes typing
  CompareSearchIndex.get();

  const host = btn.closest('.compare-placeholder') || btn.closest('.compare-empty-state');
  const picker = host?.querySelector('.compare-picker-inline');
  if (!picker) return;

  const isOpen = picker.hidden === false;

  // Close all pickers first
  closeAllInlinePickers(popup);

  // If it was already open, stop here (toggle)
  if (isOpen) return;

  picker.hidden = false;

  const input = picker.querySelector('.compare-picker__input');
  const results = picker.querySelector('.compare-picker__results');

  input.value = '';
  results.innerHTML = '';
  input.focus();

  showPickerRecommendations(popup, results);
}
async function fetchCompareStarters() {
  const res = await fetch(`/ ?section_id=compare-starters`, { headers: { Accept: 'text/html' } });
  if (!res.ok) return '';
  return await res.text();
}

document.addEventListener('click', (e) => {
  // the panel's own close button and the backdrop both close the drawer via a synthetic click on its summary
  if (e.target.closest('.compare-mobile-add__panel-close') || e.target.closest('.compare-mobile-add__backdrop')) {
    const summary = e.target.closest('menu-drawer.compare-mobile-add__drawer')?.querySelector('summary');
    if (summary) summary.dispatchEvent(new Event('click'));
    return;
  }

  const addBtn = e.target.closest('.compare-add-slot-button');
  if (addBtn) {
    openInlinePicker(addBtn);
    return;
  }

  const pickBtn = e.target.closest('[data-compare-pick-id]');
  if (pickBtn) {
    const popup = getPopup(pickBtn);
    const picker = pickBtn.closest('.compare-picker-inline');
    const mobileAddDrawer = pickBtn.closest('menu-drawer.compare-mobile-add__drawer');
    const productId = pickBtn.getAttribute('data-compare-pick-id');
    const category = pickBtn.getAttribute('data-compare-category');

    BtCompareUtil.toggleProductToCompare(productId, category);
    BtCompareUtil.loadedContent = false;
    popup.loadContent();

    // .block pickers close themselves instead of being hidden here
    if (picker && !picker.classList.contains('block')) picker.hidden = true;

    if (mobileAddDrawer) {
      // synthetic click on <summary>, same technique as BackButtonMenu, exercises the real close path
      const summary = mobileAddDrawer.querySelector('summary');
      if (summary) summary.dispatchEvent(new Event('click'));

      // restore the modal's focus trap, which closing the drawer just tore down
      const modal = popup.closest('modal-dialog');
      if (modal) trapFocus(modal, popup);
    }

    return;
  }
});


// Input handling
document.addEventListener('input', async (e) => {
  const input = e.target.closest('.compare-picker__input');
  if (!input) return;

  const picker = input.closest('.compare-picker-inline');
  if (!picker) return;

  const resultsEl = picker.querySelector('.compare-picker__results');
  const q = input.value.trim();

  if (q.length < 2) {
    // clearing the query reverts to default suggestions instead of stale results
    const popup = getPopup(input);
    if (popup) showPickerRecommendations(popup, resultsEl);
    return;
  }

  if (!CompareSearchIndex.isReady()) {
    resultsEl.innerHTML = `<div class="compare-picker__empty">Loading products…</div>`;
  }

  const products = await CompareSearchIndex.search(q, getScopedActiveCategory());

  // hide items already in compare (any category)
  const current = new Set(BtCompareUtil.getAllIds().map(String));
  const filtered = products.filter((p) => !current.has(String(p.id)));

  resultsEl.innerHTML =
    filtered
      .map(p => {
        const displayTitle = p.title || '';
        const model = p.model || '';

        const img = p.image
          ? `<img class="compare-picker__image" src="${p.image}" alt="${displayTitle.replace(/"/g, '&quot;')}" loading="lazy">`
          : `<div class="compare-picker__image compare-picker__image--placeholder" aria-hidden="true"></div>`;

        return `
          <button type="button" class="compare-picker__item" data-compare-pick-id="${p.id}" data-compare-category="${p.category || ''}">
            ${img}
            <div class="compare-picker__content">
              ${model ? `<div class="compare-picker__meta">${model}</div>` : ''}
              <div class="compare-picker__title">${displayTitle}</div>
            </div>
          </button>
        `;
      })
      .join('') || `<div class="compare-picker__empty">No results</div>`;
});


document.addEventListener('click', (e) => {
  const clearBtn = e.target.closest('.compare-picker__clear');
  if (!clearBtn) return;

  const wrapper = clearBtn.closest('.compare-picker__input-wrapper');
  const picker = clearBtn.closest('.compare-picker-inline');
  const input = wrapper.querySelector('.compare-picker__input');
  const results = picker.querySelector('.compare-picker__results');

  if (input.value.length > 0) {
    input.value = '';
    results.innerHTML = '';
    input.focus();
  } else if (!picker.classList.contains('block')) {
    // .block picker has no reopen button, so it can't be dismissed this way
    picker.hidden = true;
  }
});

function isPickerOpen(picker) {
  return picker && picker.hidden === false;
}

function openPickerForInput(input) {
  const picker = input.closest('.compare-picker-inline');
  if (!picker) return;

  const popup = getComparePopupFromEventTarget(input) || getPopup(input);
  if (!popup) return;

  closeAllInlinePickers(popup);
  picker.hidden = false;
  input.focus();

  // safety net in case the empty state's suggestions never loaded
  const results = picker.querySelector('.compare-picker__results');
  if (picker.closest('.compare-empty-state') && results && !results.innerHTML.trim() && input.value.trim().length < 2) {
    showPickerRecommendations(popup, results);
  }
}


document.addEventListener('click', (e) => {
  if (e.target.closest('.compare-add-slot-button')) return;

  const input = e.target.closest('.compare-picker__input');
  if (input) {
    openPickerForInput(input);
    return;
  }

  if (e.target.closest('.compare-picker-inline')) return;

  const anyPopup = e.target.closest('compare-popup') || document.querySelector('compare-popup');
  if (!anyPopup) return;

  closeAllInlinePickers(anyPopup);
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const openPicker = document.querySelector('.compare-picker-inline:not([hidden])');
  if (openPicker && !openPicker.classList.contains('block')) openPicker.hidden = true;
});


async function fetchCompareRecommendations(productId) {
  const url = `/recommendations/products?section_id=compare-recommendations&product_id=${encodeURIComponent(productId)}&limit=8`;
  const res = await fetch(url, { headers: { Accept: 'text/html' } });
  if (!res.ok) return '';
  return await res.text();
}

function buildFilteredPickerContainer(htmlText, currentSet, category) {
  const doc = new DOMParser().parseFromString(htmlText, 'text/html');

  const container = doc.body;

  container.querySelectorAll('[data-compare-pick-id]').forEach((btn) => {
    const id = btn.getAttribute('data-compare-pick-id');
    if (currentSet.has(String(id))) {
      btn.remove();
      return;
    }
    // Keep the tabs apples-to-apples: only suggest products matching the category being compared
    if (category && btn.getAttribute('data-compare-category') !== category) btn.remove();
  });

  return container;
}

